import { render } from "./GoToForgotPassword.vue?vue&type=template&id=17ebc1c4&scoped=true&ts=true"
import script from "./GoToForgotPassword.ts?vue&type=script&lang=ts&external"
export * from "./GoToForgotPassword.ts?vue&type=script&lang=ts&external"

import "./GoToForgotPassword.scss?vue&type=style&index=0&id=17ebc1c4&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17ebc1c4"]])

export default __exports__